import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Form, FormGroup, Input } from "reactstrap";
import { Card, CardBody, CardHeader, CardTitle, CardFooter, Button, CustomInput } from "reactstrap";
import { getLocations } from "services/dataservice";
import { addStore, editStore } from "services/dataservice";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { getIntegrationLocation } from "services/dataservice";
import { createIntegrationLocation } from "services/dataservice";

export function AddStoreShopify(props) {
  const [userMarketplaceName, setUserMarketplaceName] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const [shopUrl, setShopUrl] = useState("");
  const [shippingProvider, setShippingProvider] = useState("");
  const [userMarketplaceId, setUserMarketplaceId] = useState(0);
  const [syncInventory, setSyncInventory] = useState(true);
  const [basicAuth, setBasicAuth] = useState(false);
  const [integrationLocation, setIntegrationLocation] = useState(null);
  const queryClient = useQueryClient();

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["locations", { userMarketplaceId }],
    queryFn: () => getLocations({ userMarketplaceId }),
    enabled: false,
  });

  const { data: location, isFetching: isLocationFetching } = useQuery({
    queryKey: ["location", { userMarketplaceId }],
    queryFn: () => getIntegrationLocation({ userMarketplaceId }),
    enabled: props.edit === true && userMarketplaceId !== 0,
  });

  const createMutation = useMutation(createIntegrationLocation, {
    onSuccess: () => {
      queryClient.invalidateQueries(["location"]);
    },
  });

  const locations = data?.data?.data ?? [];

  const dbIntegrationLocation = location?.data?.data ?? "";

  const history = useHistory();

  useEffect(() => {
    if (props.edit) {
      const u = props.selectedMarketplace;

      let j = JSON.parse(u.secretKey);

      setUserMarketplaceName(u.storeName);
      setUserMarketplaceId(u.userMarketplaceId);
      setShopUrl(j.ShopUrl);
      setApiKey(j.ApiKey);
      setApiSecret(j.SecretKey);
      setShippingProvider(u.shippingProvider);
      setSyncInventory(u.syncInventory);
      setBasicAuth(u.basicAuth);
    }
  }, [props.selectedMarketplace]);
  const onSubmit = async () => {
    if(!Boolean(shippingProvider)){
      props.showFail("Shipping Provider is required")
      return
    }
    try {
      if (props.edit) {
        const resp = await editStore({
          userMarketplaceId,
          storeName: userMarketplaceName,
          marketplaceId: props.selectedMarketplace.marketplaceId,
          apiKey,
          shopUrl,
          secretKey: apiSecret,
          active: true,
          integrated: false,
          shippingProvider: shippingProvider,
          syncInventory,
          basicAuth,
        });
      } else {
        const resp = await addStore({
          storeName: userMarketplaceName,
          marketplaceId: props.selectedMarketplace.marketplaceId,
          shopUrl,
          apiKey,
          secretKey: apiSecret,
          shippingProvider: shippingProvider,
          syncInventory,
          basicAuth,
        });
        if(apiSecret.includes("shpss_")){
          window.open(resp.data.authorizeUrl)
        }
      }

      history.push("/admin/integration/list");
    } catch (err) {
      const errResp = err.response;
      if (errResp.status === 400) {
        if (errResp.data.error === "duplicated_store_name") {
          props.showFail("Duplicated Store Name");
        }
      }
    }
  };

  const Loading = ({ msg }) => (
    <ReactBSAlert
      info
      style={{ display: "block", marginTop: "-100px" }}
      title={msg}
      onConfirm={() => {}}
      showConfirm={false}
      btnSize=""
    ></ReactBSAlert>
  );

  return (
    <Card>
      {(isFetching || isLocationFetching || createMutation.status === "loading") && <Loading msg="loading" />}
      <CardHeader>
        <CardTitle tag="h4">Selected store: {props.selectedMarketplace.name}</CardTitle>
      </CardHeader>
      <CardBody>
        <Form>
          <FormGroup>
            <label>Name</label>
            <Input
              type="text"
              value={userMarketplaceName}
              onChange={(e) => setUserMarketplaceName(e.target.value)}
            ></Input>
          </FormGroup>
          <FormGroup>
            <label>Shop URL</label>
            <Input type="text" value={shopUrl} onChange={(e) => setShopUrl(e.target.value)}></Input>
          </FormGroup>
          <FormGroup>
            <label>API Key</label>
            <Input type="text" value={apiKey} onChange={(e) => setApiKey(e.target.value)}></Input>
          </FormGroup>
          <FormGroup>
            <label>API Secret</label>
            <Input
              type="text"
              value={apiSecret}
              onChange={(e) => setApiSecret(e.target.value)}
            ></Input>
          </FormGroup>
          <FormGroup>
            <label>Shipping Provider</label>
            {/* <Input
              type="text"
              value={shippingProvider}
              onChange={(e) => setShippingProvider(e.target.value)}
            ></Input> */}
            <Input name="ShippingProvider" value={shippingProvider} type="select" onChange={(e) => setShippingProvider(e.target.value)}>
              <option value=""></option>
              <option value="eTrax">eTrax</option>
              <option value="eTrax2.0">eTrax2.0</option>
            </Input>
          </FormGroup>
          {props.edit && (
            <FormGroup>
              <label>Current Location</label>
              <Input type="text" value={dbIntegrationLocation} disabled={true}></Input>
            </FormGroup>
          )}
          {props.edit && (
            <FormGroup>
              <label>Change Location</label>
              <Input
                type="select"
                onChange={(e) => {
                  if (e.target.value === "") {
                    setIntegrationLocation(null);
                    return;
                  }
                  var selectedLocation = locations.filter((x) => x.value === e.target.value)[0];
                  console.log(selectedLocation);
                  setIntegrationLocation(selectedLocation);
                }}
              >
                <option key="" value=""></option>
                {locations.map((x) => (
                  <option key={x.value} value={x.value}>
                    {x.name}
                  </option>
                ))}
              </Input>
              <Button color="info" onClick={refetch} disabled={locations.length > 0}>
                Get Location
              </Button>
              <Button
                color="success"
                onClick={() => {
                  createMutation.mutate({
                    userMarketplaceId,
                    name: integrationLocation.name,
                    value: integrationLocation.value,
                  });
                }}
                disabled={locations.length === 0 || integrationLocation === null}
              >
                Update Location
              </Button>
            </FormGroup>
          )}
          <FormGroup>
            <label>Sync Inventory</label>
            <CustomInput
              type="switch"
              id="idIntegrated"
              name="integrated"
              label="Sync Inventory"
              onChange={(e) => setSyncInventory(e.target.checked)}
              checked={syncInventory}
            />
          </FormGroup>
          <FormGroup>
            <label>Basic Auth</label>
            <CustomInput
              type="switch"
              id="idBasicAuth"
              name="basicAuth"
              label="Basic Auth"
              onChange={(e) => setBasicAuth(e.target.checked)}
              checked={basicAuth}
            />
          </FormGroup>
        </Form>
      </CardBody>
      <CardFooter>
        <Button color="primary" onClick={onSubmit}>
          Submit
        </Button>
      </CardFooter>
    </Card>
  );
}
